/* eslint-disable jsx-a11y/control-has-associated-label */
import React from 'react';

// eslint-disable-next-line @typescript-eslint/naming-convention
type CheckBoxProps = {
  checkName?: string;
  label?: string;
  labelText?: string;
  id?: string;
  onClick?: any;
  media?: string;
  mediaAlt?: string;
  checked?: boolean;
};

const Checkbox = ({
  checkName,
  id,
  onClick,
  media,
  mediaAlt,
  label,
  labelText,
  checked,
}: CheckBoxProps): JSX.Element => {
  return (
    <>
      <div className="form-checkbox" data-testid="form-checkbox">
        <button
          id={id}
          name={checkName}
          type="button"
          className={checked ? 'checkbox checked' : 'checkbox'}
          data-testid="checkbox-component"
          onClick={onClick}
        />
        {media ? (
          <div>
            <img src={media} alt={mediaAlt} data-testid="check-media" />
          </div>
        ) : (
          <span className="text-black">
            {label} <strong>{labelText}</strong>
          </span>
        )}
      </div>
    </>
  );
};

export default Checkbox;
